<template>
<div>
<b-card>
  <div slot="header">
    <h4 class="mr-5 pull-left">{{$t('INSTITUTIONS')}}</h4>
   <new-button :c_permission="C_INSTITUTION_EDIT_BUTTON"
               @click="newInstitution"
               button_type="new" variant="primary"
              class="pull-right" >{{$t('NEW')}}
    </new-button>
  </div>
  <div class="table-responsive">
    <table class="table hover" v-if="items && items.length > 0">
      <thead>
      <tr>
        <th>{{$t('NAME')}}</th>
        <th>{{$t('ECONOMY')}}</th>
        <th>{{$t('EDIT')}}</th>
      </tr>
      </thead>
      <tbody>
      <tr :key="index" v-for="(item,index) in items">
        <td>{{item.name}}</td>
        <td>{{item.economy.name}}</td>
        <td><institution-edit-button
                  :c_permission="C_INSTITUTION_EDIT_BUTTON"
                  @click="edit(item)">
            </institution-edit-button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <institution-aside :state="institutionEditAsidePanelState" v-on:closeAside="institutionEditAsidePanelState=false">
      <institution-edit-form @closePanel="updatePanel($event)" :itemEdit="itemEdit" @updated="institution"></institution-edit-form>
  </institution-aside>
</b-card>
</div>
</template>

<script>
  import routeNames from '@/router/routeNames'
  import NewButton from '@/components/app/AppButton'
  import InstitutionEditButton from '@/components/app/AppEdit'
  import InstitutionEditForm from '@/components/institution/InstitutionEditForm'
  import InstitutionAside from '@/components/app/AppAside'
  import {getInstitutionList} from '@/services/institution/index'
  import {C_INSTITUTION_EDIT_BUTTON} from '@/shared/component_permission'

    export default {
        name: "Index",
      data(){
          return {
            items:[],
            fields: [
              {key: 'name', label: this.$t('NAME')},
              {key: 'edit', label: this.$t('EDIT')}
            ],
            id:null,
            institutionEditAsidePanelState:false,
            itemEdit:null,
            C_INSTITUTION_EDIT_BUTTON
          }

      },
      components: {
        NewButton,
        InstitutionEditButton,
        InstitutionEditForm,
        InstitutionAside
      },
      methods:{
         institution() {
           getInstitutionList()
           .then(response => {
             this.items = response.data
           })
           this.itemEdit = null
         },
         edit(value) {
           this.itemEdit = value,
           this.institutionEditAsidePanelState = true
         },
         newInstitution() {
           this.itemEdit = null,
           this.institutionEditAsidePanelState = true
         },
         updatePanel() {
           this.institutionEditAsidePanelState = false
           this.itemEdit = null
         }

      },
      async mounted() {
        await this.institution();
      }
    }
</script>

<style scoped>

</style>
